<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Za spremembo varnostnega paketa ali naročilo dodatnih statičnih IP naslovov vas prosimo, da nas
          kontaktirate na
          <b>
            {{ kontaktniPodatki.T2_INFO_EMAIL }}
          </b>
          ali pokličite na
          <b>
            {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}
          </b>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'

export default {
  name: 'InfoKomponentaNaroceneStoritve',
  data () {
    return {
      kontaktniPodatki: ''
    }
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
  }
}
</script>
<style scoped>
.info-okvir {
  width: 610px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1300px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Pregledstoritev/InfoKomponentaNaroceneStoritve.vue